import Movie from "../Component/Movie";

const Action = () => {
  return (
    <div>
      <Movie />

      <h1>These are the action</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam facere,
        velit, id voluptatem optio excepturi nostrum eveniet vero, obcaecati
        earum aut quae ipsam magnam. Quasi, saepe et! Quibusdam, recusandae
        amet?
      </p>
    </div>
  );
};

export default Action;
